module.exports = __webpack_public_path__ + "static/eventPerson2-dd532a882feffd41ad8e7607b9d4de1e.jpeg";